import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/figure/figure.tsx
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Figure = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, asChild, className } = _b, rest = __objRest(_b, ["children", "asChild", "className"]);
    const Component = asChild ? Slot : "figure";
    return /* @__PURE__ */ jsx(Component, __spreadProps(__spreadValues({ ref, className: clsx("hds-figure", className) }, rest), { children }));
  }
);
Figure.displayName = "Figure";

export {
  Figure
};
//# sourceMappingURL=chunk-OE6RISJS.mjs.map